import React, { FC } from 'react';
import cn from 'classnames';

import { scrollTop } from 'crehana-utils/scroll';

import { BaseCuiFCProps } from 'crehana-ui/helpers/types';
import { white } from 'crehana-ui/styles/colors';
import transition from 'crehana-ui/styles/transition';

import NewArrowRight from 'crehana-icons/NewArrowRight';

type ScrollTopFABProps = BaseCuiFCProps & {
  /*
   * Optional custom function on click.
   *
   * @default scrollTop from 'Jsx/Utils/scroll'
   */
  onScrollTop?: () => void;
};

const ScrollTopFAB: FC<ScrollTopFABProps> = ({
  className,
  onScrollTop,
  css: cssProp,
  ...scrollTopFABProps
}) => {
  const onClick = () => {
    if (typeof onScrollTop === 'function') {
      onScrollTop();
    } else {
      scrollTop();
    }
  };

  return (
    <button
      type="button"
      className={cn(
        'flex flex-shrink-0 items-center justify-center bg-secondary-main hover:bg-secondary-light w-32 h-32 rounded-full focus:outline-none',
        className,
      )}
      css={`
        transition: ${transition('background-color')};
        & > svg {
          transform: rotate(-90deg);
        }
        ${cssProp}
      `}
      onClick={onClick}
      {...scrollTopFABProps}
    >
      <NewArrowRight color={white} size={16} />
    </button>
  );
};

export default ScrollTopFAB;
